import { render, staticRenderFns } from "./ThirdPartiesList.vue?vue&type=template&id=19f2098c&"
import script from "./ThirdPartiesList.vue?vue&type=script&lang=js&"
export * from "./ThirdPartiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports